export function Stat({ number, label }) {
  return (
    <div className="p-6 bg-white rounded-xl shadow-md border border-[#E5D9F2]">
      <h4 className="text-3xl font-extrabold mb-2 text-[#6A0DAD]">
        {number}
      </h4>
      <p className="text-[#5A3D73]">
        {label}
      </p>
    </div>
  );
}
